import styled, { css } from "styled-components/native";

export const StyledContainer = styled.View<any>`
	bottom: ${(props) => (props.isNarrow ? 8 : 24)}px;
	left: calc(50% - 478px);
	z-index: 1;
	position: fixed;
	width: 956px;
	transition: all 0.3s ease;
`;

export const StyledFont = styled.View<any>`
	user-select: none;
	${(props) =>
		!props.label &&
		css`
			text-align: center;
			align-items: center;
			justify-content: center;
		`}
`;

export const StyledText = styled.Text<any>`
	font-size: ${(props) => (props.isNarrow ? 21 : 25)}px;
	font-weight: 300;
	color: white;
`;
